import React from 'react'
import app from '../login/firebase'
import NavigationBar from '../components/nav';
import {Container} from "react-bootstrap"
class Account extends React.Component {
    constructor(props) {
        super (props)
        this.state = {}
    }
    render () {
        return(
            <div>
                <NavigationBar/>
                <Container>
                    
                </Container>

            </div>
        )
    }
}

export default Account